import React from 'react'
import {useIntl} from 'react-intl'
import {Button, InputSearch} from '../../../../_gori/partials/widgets'
import {KTSVG, toAbsoluteUrl} from '../../../../_gori/helpers'
import FileSaver from 'file-saver'
import {MOBILE_BREAKPOINT, TABLET_BREAKPOINT} from '../../../../_gori/constants/_layout'
import useWindowDimensions from '../../../../_gori/hooks/useWindowDimensions'
import clsx from 'clsx'

const BatchesFilter: React.FC = () => {
  const intl = useIntl()
  const {width} = useWindowDimensions()

  return (
    <div className='d-flex flex-column flex-fill'>
      <div className='d-flex flex-wrap justify-content-between align-items-start gap-3'>
        <div
          className={clsx('d-flex align-items-start position-relative filter-toolbar-44', {
            'w-100': width < TABLET_BREAKPOINT,
          })}
        >
          <InputSearch placeholder={intl.formatMessage({id: 'SEARCH_BATCH'})} />
        </div>
        <div
          className={clsx('d-flex flex-row flex-wrap gap-3 align-items-start filter-toolbar-44', {
            'w-100': width < TABLET_BREAKPOINT,
            'flex-column': width <= MOBILE_BREAKPOINT,
          })}
        >
          <Button
            event={() =>
              FileSaver.saveAs(
                toAbsoluteUrl('/media/gori/batches/ShipBae_Batch_Template_Domestic.csv'),
                'ShipBae_Batch_Template_Domestic.csv'
              )
            }
            classNameDiv={clsx({
              'col-5': width < TABLET_BREAKPOINT,
              'col-12': width <= MOBILE_BREAKPOINT,
            })}
            className='btn btn-advanced-secondary btn-sm fw-bolder rounded-2 w-100 align-items-center justify-content-center'
            label={intl.formatMessage({id: 'BATCH_TEMPLATE'})}
            children={<KTSVG path='/media/gori/batches/file_download.svg' />}
          />
          <Button
            event={() =>
              FileSaver.saveAs(
                toAbsoluteUrl('/media/gori/batches/ShipBae_Batch_Template_International.csv'),
                'ShipBae_Batch_Template_International.csv'
              )
            }
            classNameDiv={clsx({
              'flex-1': width < TABLET_BREAKPOINT,
              'col-12': width <= MOBILE_BREAKPOINT,
            })}
            className='btn btn-advanced-secondary btn-sm fw-bolder rounded-2 w-100 align-items-center justify-content-center'
            label={intl.formatMessage({id: 'BATCH_TEMPLATE_INTL'})}
            children={<KTSVG path='/media/gori/batches/file_download.svg' />}
          />
        </div>
      </div>
    </div>
  )
}

export {BatchesFilter}
